import React from 'react';
import Calendar from '../Calendar';
import StyledCard from './components/StyledCard.jsx';
import EngineeringTimesheet from '../Engineering/EngineeringTimesheet.jsx';

const EngineeringHome = () => {
  return (
    <StyledCard>
      <>
        <div data-test="grid-display">            
          <>
            <Calendar/>
            <EngineeringTimesheet />        
          </>
        </div>
      </>     
    </StyledCard>
  );
}

export default EngineeringHome;
